<template>
  <b-card>
    <div class="row">
      <b-form-group label="Location Type" label-for="location-type" class="col-lg-12">
        <b-select v-model="food._type" id="location-type" name="location-type" v-validate="{ required: true }"
          :state="validateState('food._type')">
          <option :value="null" selected>Select a Type</option>
          <option value="Bakery">Bakery</option>
          <option value="BarLoungeNightclubOrTavern">Bar, Lounge, Nightclub or Tavern</option>
          <option value="BreweryOrDistillery">Brewery or Distillery</option>
          <option value="CoffeeShopOrTeaRoom">Coffee Shop or Tea Room</option>
          <option value="DelicatessenLunchCounterOrSodaFountain">Delicatessen, Lunch Counter or Soda Fountain</option>
          <option value="IceCreamOrDessertShop">Ice Cream or Dessert Shop</option>
          <option value="FoodTruck">Food Truck</option>
          <option value="Restaurant">Restaurant</option>
        </b-select>
        <div class="red"><font-awesome-icon v-if="veeErrors.first('location-type')" icon="exclamation-circle" size="1x"
            style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('location-type') }}</div>
      </b-form-group>
    </div>

    <div class="row">
      <b-form-group label="Menu URL" label-for="menuUrl" class="col-lg-4">
        <b-form-input type="text" id="menuUrl" name="menuUrl" v-model="food.menu" @change="onChange" />
        <b-form-invalid-feedback class="d-block red" v-if="this.food.menu && !urlTest.test(this.food.menu)">Must include
          http:// or https://</b-form-invalid-feedback>
      </b-form-group>

      <TelephoneInput label="Telephone" id="phone" name="phone" v-model="food.phone" @input="dirty = true"
        @change="onChange" class="col-lg-4" />
      <!-- <b-form-group label="Telephone" label-for="phone" class="col-lg-4">
          <b-form-input type="tel" id="phone" name="phone" v-mask="'(###) ###-####'" @input="dirty=true" v-model="food.phone" @change="onChange" v-validate="{ required: true }" :state="validateState('food.phone')" />
          <div class="red"><font-awesome-icon v-if="veeErrors.first('phone')" icon="exclamation-circle" size="1x" style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('phone') }}</div>
        </b-form-group> -->

      <b-form-group label="Hours Of Operation" label-for="hoursOfOperation" class="col-lg-4">
        <b-form-input id="hours" name="hours" v-model="food.hoursOfOperation" @change="onChange"
          v-validate="{ required: true }" :state="validateState('food.hoursOfOperation')" />
        <div class="red"><font-awesome-icon v-if="veeErrors.first('hours')" icon="exclamation-circle" size="1x"
            style="color:red;" class=" mr-1 fas fa-exclamation-circle" />{{ veeErrors.first('hours') }}</div>
      </b-form-group>
    </div>

    <div class="row mb-3">
      <div class="col-lg-12">
        <b-form-group label="Discounts" class="">
          <b-card>
            <b-form-checkbox-group id="discounts" name="Discounts" v-model="food.discounts" @change="onChange"
              style="column-count: 2;" stacked>
              <b-form-checkbox value="AAA">AAA</b-form-checkbox>
              <b-form-checkbox value="Government">Government</b-form-checkbox>
              <b-form-checkbox value="Military">Military</b-form-checkbox>
              <b-form-checkbox value="Senior">Senior</b-form-checkbox>
            </b-form-checkbox-group>
          </b-card>
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-12">
        <b-form-group label="Credit Cards Accepted" label-for="creditCards">
          <credit-cards :value="food.creditCards" v-model="food.creditCards" @change="onChange" />
        </b-form-group>
      </div>
    </div>

    <div class="row">
      <div v-if="($store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor') && locationId"
        class="col-lg-6">
        <h1>BBQ Trail</h1>
        <b-form-group label="Featured in the BBQ Trail" label-for="featured">
          <b-form-checkbox switch id="featured" name="featured" v-model="food.featured" @change="onChange" />
        </b-form-group>
      </div>
      <div v-if="($store.state.auth.user.role === 'admin' || $store.state.auth.user.role === 'editor' || $store.state.auth.user.role === 'limited_editor') && locationId"
        class="col-lg-6">
        <h1>BBQ Trail Images</h1>
        <photos :files="food.photos" type="BBQ" v-on:updateFiles="updatePhotos" ref="photoUpload"
          :locationId="locationId" />
      </div>
    </div>
  </b-card>
</template>

<script>
import { required } from 'vuelidate/lib/validators';
import creditCards from '../../../components/CreditCards.vue';
import photos from '../../../components/Photos.vue';
import TelephoneInput from '../../../components/TelephoneInput.vue';
// import hours from './hoursOfOperation.vue';

export default {
  components: {
    creditCards,
    photos,
    TelephoneInput,
    // hours,
  },
  data() {
    return {
      urlTest: /(http(s?)):\/\//i,
      food: {
        discounts: '',
        creditCards: [],
        featured: false,
        photos: [],
        menu: '',
        hours: {},
        phone: '',
        hoursOfOperation: {},
      },
      submitted: false,
    };
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    locationId: {
      type: String,
      required: false,
    },
  },
  validations: {
    food: {
      phone: {
        required,
      },
      hoursOfOperation: {
        required,
      },
    },
  },
  mounted() {
    this.food = this.value;
  },
  methods: {
    updatePhotos(photoFiles) {
      this.food.photos = photoFiles;
    },
    async save() {
      if (this.$refs.photoUpload.files.length > 0) {
        await this.$refs.photoUpload.uploadFiles();
      }
    },
    onChange() {
      this.$emit('input', this.food);
      this.$emit('change', this.food);
    },
    validate() {
      this.submitted = true;
      this.$v.$touch();
      return !this.$v.$invalid;
    },
    validateState(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.veeErrors.has(ref);
      }
      return null;
    },
  },
};
</script>

<style></style>
